import baseComponent from "@/scripts/baseComponent";
import authApi from "@/api/auth";
import VueRecaptcha from 'vue-recaptcha';
import { regex } from "@/constant/config";
import '@/assets/login-v4-theme/vendor/animate/animate.css';
import '@/assets/login-v4-theme/vendor/css-hamburgers/hamburgers.min.css';
import '@/assets/login-v4-theme/vendor/animsition/css/animsition.min.css';
import '@/assets/login-v4-theme/css/util.css';
import '@/assets/login-v4-theme/css/main.css';

const minBgIndex = 1;
const maxBgIndex = 4;
const enableRecaptcha = (process.env.VUE_APP_ENABLED_RECAPTCHA == 'true');
export default {
    extends: baseComponent,
    components: { VueRecaptcha },
    data() {
        var validatePassword = (rule, value, callback) => {
            if (value.match(regex.password)) {
                if (!value.match(regex.passwordAtLeastUppercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastUppercaseChar));
                if (!value.match(regex.passwordAtLeastLowercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastLowercaseChar));
                if (!value.match(regex.passwordAtLeastNumber)) return callback(new Error(this.$lang.register.passwordAtLeastNumber));
                if (!value.match(regex.passwordAtLeastSpecialChar)) return callback(new Error(this.$lang.register.passwordAtLeastSpecialChar));
                if (!value.match(regex.passwordAtNoSpace)) return callback(new Error(this.$lang.register.passwordAtNoSpace));
                return callback();
            } else {
                return callback(new Error(this.$lang.register.validationTypePassword));
            }
        };
        var validateConfirmPassword = (rule, value, callback) => {
            if (value !== this.reactiveForm.newPassword) {
                return callback(new Error(this.$lang.changePassword.validationConfirmPasswordMatch));
            } else {
                if (value.match(regex.password)) {
                    if (!value.match(regex.passwordAtLeastUppercaseChar)) return callback(new Error(this.$lang.changePassword.passwordAtLeastUppercaseChar));
                    if (!value.match(regex.passwordAtLeastLowercaseChar)) return callback(new Error(this.$lang.changePassword.passwordAtLeastLowercaseChar));
                    if (!value.match(regex.passwordAtLeastNumber)) return callback(new Error(this.$lang.changePassword.passwordAtLeastNumber));
                    if (!value.match(regex.passwordAtLeastSpecialChar)) return callback(new Error(this.$lang.changePassword.passwordAtLeastSpecialChar));
                    if (!value.match(regex.passwordAtNoSpace)) return callback(new Error(this.$lang.changePassword.passwordAtNoSpace));
                    return callback();
                } else {
                    return callback(new Error(this.$lang.register.validationTypePassword));
                }
            }
        };
        return {
            enabledRecaptcha: enableRecaptcha,
            visiblePopoverPassword: false,
            isLoadUserInfoDone: false,
            reactiveForm: {
                appCode: this.$lang.common.appCode,
                newPassword: '',
                retypeNewPassword: '',
                recaptchaToken: "",
                deviceInformation: '',
            },
            reactiveRules: {
                newPassword: [
                    {
                        required: true,
                        message: this.$lang.login.validationRequiredPassword,
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        message: this.$lang.register.validationMinPassword,
                        trigger: ["blur", "change"]
                    },
                    {
                        max: 50,
                        message: this.$lang.register.validationMaxPassword,
                        trigger: ["blur", "change"]
                    },
                    { validator: validatePassword, trigger: "blur" }
                ],
                retypeNewPassword: [
                    {
                        required: true,
                        message: this.$lang.login.validationRequiredPassword,
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        message: this.$lang.register.validationMinPassword,
                        trigger: ["blur", "change"]
                    },
                    {
                        max: 50,
                        message: this.$lang.register.validationMaxPassword,
                        trigger: ["blur", "change"]
                    },
                    { validator: validateConfirmPassword, trigger: "blur" }
                ],
            },
            reactiveUserInfo: null,
        }
    },
    computed:{
        canSubmitForm() {
            return ((!this.enabledRecaptcha || this.reactiveForm.recaptchaToken !== '') && this.reactiveForm.newPassword !== '' && this.reactiveForm.retypeNewPassword !== '');
        },
        randomBackground() {
            let rndInt = Math.floor(Math.random() * maxBgIndex) + minBgIndex;
            try{
            let lastRandom = localStorage.getItem('randomBackground') || 1;
            let countLoop = 0;
            while(lastRandom === rndInt) {
                rndInt = Math.floor(Math.random() * maxBgIndex) + minBgIndex;
                countLoop++;
                if(countLoop === 6) break;
            }
            localStorage.setItem('randomBackground', rndInt);
            }catch{}
            return rndInt;
        },
        reactiveToken(){
            return this.$route.query.token;
        }
    },
    created() {
        this.isLoading = true;   
        this.retryUserInfomations();     
    },
    methods: {  
        verifyRecaptcha(response) {
            //console.log("verifyRecaptcha", response);
            this.$set(this.reactiveForm, "recaptchaToken", response);
        },
        expiredRecaptcha() {
            if (this.enabledRecaptcha) {
                this.$set(this.reactiveForm, "recaptchaToken", "");
                if (this.$refs.recaptchaComp) this.$refs.recaptchaComp.reset();
                this.enabledRecaptcha = false;
                this.enabledRecaptcha = process.env.VUE_APP_ENABLED_RECAPTCHA;
            }
        },
        renderRecaptcha(id) {
            //console.log("renderRecaptcha", id);
        },
        errorRecaptcha() {
            //console.log("errorRecaptcha");
        },
        resetRecaptcha() {
            console.log('resetCapcha')
            if (this.enabledRecaptcha) {
                this.$set(this.reactiveForm, "recaptchaToken", "");
                if (this.$refs.recaptchaComp) this.$refs.recaptchaComp.reset();
                this.enabledRecaptcha = false;
                this.enabledRecaptcha = process.env.VUE_APP_ENABLED_RECAPTCHA;
            }
        },      
        retryUserInfomations(){
            authApi.retryUserInfomations(this.reactiveToken)
                .then(res => {         
                    //console.log('retryUserInfomations', res); 
                    this.reactiveUserInfo = res.data;
                    if(res.data.linkStatus !== 3){
                        window.location = res.data.redirectLink; 
                    }
                    else{                        
                        this.isLoading = false;
                        this.isLoadUserInfoDone = true;
                    }
                })
                .catch(error => {
                    setTimeout(() => {
                        try {
                            this.isLoading = false;
                            if (error.name === 'Error') {
                                this.$store.dispatch("common/showCommonError", error);
                            } else {
                                switch (error.errorCode) {
                                    default:
                                        this.$store.dispatch("common/showUnkownError", error, `Error when retry user's infomations ...`);
                                        break;
                                }
                            }
                        } catch (error) {
                            this.$store.dispatch("common/showUnkownError", error, `Error when retry user's infomations ...`);
                        }
                    }, 1000);
                });
        },
        reActivateAccountVerifyV2(reactiveFormData){
            this.isLoading = true;
            authApi.reActivateAccountVerifyV2(reactiveFormData)
            .then(res => {         
                //console.log('reActivateAccountVerifyV2', res);
                window.location = res.data; 
                //this.isLoading = false;
            })
            .catch(error => {
                this.isLoading = false;
                setTimeout(() => {
                    try {
                        this.isLoading = false;
                        if (error.name === 'Error') {
                            this.$store.dispatch("common/showCommonError", error);
                        } else {
                            switch (error.errorCode) {
                                default:
                                    this.$store.dispatch("common/showUnkownError", error, `Error when re-active your account ...`);
                                    break;
                            }
                        }
                    } catch (error) {
                        this.$store.dispatch("common/showUnkownError", error, `Error when re-active your account ...`);
                    }
                }, 1000);
            });
        },
        // Submit form 
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.isLoading = true;
                    this.reactiveForm.deviceInformation = JSON.stringify(this.getInformationClient());
                    this.reactiveForm.reactiveToken = this.reactiveToken;
                    this.reActivateAccountVerifyV2(this.reactiveForm);                    
                } else {
                    return false;
                }
            });
        },
        
    }
}